import React, { useEffect, useState } from "react";
import { message } from "antd";
import Layout from "../components/Layout/Layout";
import "./css/Announcement.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../components/Header/SideMenu";
import {
	ChevronLeftSvg,
	ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import HeroSvg from "../components/Layout/HeroSvg";
import { apiClient } from "../config/api.client";

const Announcement = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [sideMenu, setSideMenu] = useState(false);
	const [ann, setAnn] = useState(null);

	async function getNoti() {
		try {
			const res = await apiClient.get("/noti/get-noti");
			if (res.data.success) {
				setAnn(res.data.data[0]);
				// setImage(res.data.data[0].image);
				// setLink(res.data.data[0].link);
				// setDisplay(res.data.data[0].display);
			} else {
				message.error(res.data.message);
			}
		} catch (error) {
			console.log(error);
		}
	}
	useEffect(() => {
		getNoti();
	}, []);

	const onClose = () => {
		dispatch(setActiveButton("home"));
		navigate("/");
		localStorage.setItem("activeButton", "home");
	};

	return (
		<Layout>
			<div className="announcement-container d-none d-md-block d-lg-block">
				<div className="anncontainer">
					<img src={ann?.image} alt="" />
					<p>{ann?.desc}</p>
				</div>
			</div>

			<div className={`account-modal-container d-lg-none d-md-none `}>
				<HeroSvg />
				<div className="account-modal-container-content">
					<div className="top-left-content">
						<div className="box-1 center" onClick={onClose}>
							<ChevronLeftSvg />
						</div>
						<h2 className="mb-0">Announcement</h2>
					</div>
					<div
						className="top-right-content box-2 center"
						onClick={() => setSideMenu(!sideMenu)}
					>
						<ListSvg />
					</div>
				</div>

				<div className="announcement-container d-flex d-md-none d-lg-none">
					<div className="anncontainer">
						<img src={ann?.image} alt="" />
						<p>{ann?.desc}</p>
					</div>
				</div>
			</div>

			<SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
		</Layout>
	);
};

export default Announcement;
